import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { PROJECTS } from '../../../constants/applicationConstants';
import { ErrorFallback, DataTableHoc } from 'smart-react';
import { GridColumnsList } from '../Components/Filter/FilterElements';
import DataColumns from '../Components/DataColumns/DataColumns';
import { Card } from '@progress/kendo-react-layout';
import SelectProjectForm from '../Components/SelectProjectForm/SelectProjectForm';

import {
  ROW_LAYOUTS,
  PAGE_SIZE,
} from '../../../constants/applicationConstants';

import {
  deleteFilter,
  applyFilter,
  saveFilters,
} from '../../../Utils/Filters/filterSliderHandler';

const BaseDataTable = React.lazy(
  () => import('../Components/DataTable/DataTable')
);

const MainDataTable = DataTableHoc(BaseDataTable);

/**
 * Projects main screen
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The projects component.
 */
const Projects = () => {
  const [projectsData, setProjectsData] = React.useState([]);
  const dataColumnsArray = DataColumns({});
  // used to check API is ready to call
  const [isReady, setIsReady] = React.useState(false);

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      <div className="container mx-auto account-form-container">
        <div className="add-test add-test-page cards-layout-page container mx-auto">
          <div className="card-detail-content">
            <Card className="seprate-card">
              <div className="card-content">
                <SelectProjectForm />
                <MainDataTable
                  deleteFilter={deleteFilter}
                  applyFilter={applyFilter}
                  saveFilters={saveFilters}
                  moduleName={PROJECTS}
                  dataColumns={dataColumnsArray}
                  gridColumnsList={() => GridColumnsList()}
                  dataTableName={PROJECTS}
                  setIsReady={setIsReady}
                  isReady={isReady}
                  rowLayoutConfigName={`${PROJECTS}.DataGrid.RowLayout`}
                  pageLengthConfigName={`${PROJECTS}.DataGrid.ItemsPerPage`}
                  dataSet={projectsData}
                  setDataSet={setProjectsData}
                  initialSort={{
                    field: 'id',
                    dir: 'desc',
                  }}
                  isCardonMobileView={false}
                  total={process.env.DefaultLimit}
                  defaultRowLayout={process.env.RowLayout}
                  rowLayouts={ROW_LAYOUTS}
                  pageSizes={PAGE_SIZE}
                  isSelectable={true}
                />
              </div>
            </Card>
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
};
export default Projects;
